export const DEFAULT_RESPONSIVE_PROFILES = Object.freeze([
  { id: 'mobile', minWidth: 0, maxWidth: 767 },
  { id: 'tablet', minWidth: 768, maxWidth: 1023 },
  { id: 'laptop', minWidth: 1024, maxWidth: 1439 },
  { id: 'desktop', minWidth: 1440, maxWidth: null },
]);

export function resolveResponsiveProfile(tree, viewportWidth) {
  const profiles = tree.props.responsiveProfiles || DEFAULT_RESPONSIVE_PROFILES;
  return profiles.find((profile) => (
    viewportWidth >= profile.minWidth && (profile.maxWidth == null || viewportWidth <= profile.maxWidth)
  ))?.id || 'desktop';
}

export function resolveWidgetForProfile(widget, profileId) {
  const override = widget.profiles?.[profileId] || {};
  return {
    visible: override.visible !== false,
    props: { ...widget.props, ...(override.props || {}) },
  };
}
